export enum PortfolioConstructionTabs {
  SIMULATION = 'simulation',
  FRONTIER = 'frontier',
  ROLLING = 'rolling',
  PERFORMANCE_ATTRIBUTION = 'performance',
  CORRELATION = 'correlation',
  RECONCILIATION = 'reconciliation',
  COMPOSITION = 'composition',
}
